import './item-slider.scss'
import 'swiper/css';

import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', () => {
	const itemSliders = document.querySelectorAll('.js-itemSlider');

	itemSliders.forEach((sliderBlock) => {
		const sliderEl = sliderBlock.querySelector('.js-slider');
		if (!sliderEl) {
			return;
		}

		const prevEl = sliderBlock.querySelector('.js-arrowPrev');
		const nextEl = sliderBlock.querySelector('.js-arrowNext');

		/** @type {import('swiper').SwiperOptions} */
		const options = {
			modules: [Navigation],
			loop: true,
			slidesPerView: 4,
			spaceBetween: 0,
			navigation: true,
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: false,
				},
				640: {
					slidesPerView: 2,
					spaceBetween: 0,
					loop: true,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 0,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 0,
				},
			},
			watchOverflow: true,
			on: {
				transitionEnd: function() {
					// Remove the class from all slides
					const allSlides = sliderEl.querySelectorAll('.swiper-slide');
					allSlides.forEach(slide => {
						slide.classList.remove('-slideComplete');
					});
					
					// Add the class to the active slide after transition completes
					const activeSlide = sliderEl.querySelector('.swiper-slide-active');
					if (activeSlide) {
						activeSlide.classList.add('-slideComplete');
					}
				},
				init: function() {
					// Set initial active slide on init
					const activeSlide = sliderEl.querySelector('.swiper-slide-active');
					if (activeSlide) {
						activeSlide.classList.add('-slideComplete');
					}
				}
			}
		};

		if (prevEl && nextEl) {
			options.navigation = {
				prevEl,
				nextEl,
			};
		}

		// eslint-disable-next-line no-new
		new Swiper(sliderEl, options);
	});
});

